import axios from 'axios';
import { trackPromise } from 'react-promise-tracker';
import AppConfig from '../../appConfig';
import { getBrowserClientId } from '../../common/utils';

export const getAxios = (url, axiosRequestConfig) => {
    axiosRequestConfig.headers = {
        'Url': url,
        'Step': 'DataCall',
        'IsWebService': '0',
        'elapsedTime': 0,
        'browserClientId': getBrowserClientId(),
        env: AppConfig.appMode,
        authorization: AppConfig.getAuthToken(),
        connectionId: sessionStorage.getItem('tabId') ? sessionStorage.getItem('tabId') : AppConfig.env('connectionId'),
    };
    url = AppConfig.apiUrl + url;
    var respLoader = trackPromise(axios({
        method: 'get',
        url: url,
        data: axiosRequestConfig.params,
        headers: axiosRequestConfig.headers,
        callTime: axiosRequestConfig.params.callTime,
    })
        .then((response) => {
            return response?.data;;
        })
        .catch((response) => {
            console.log(response);
        }))
    return respLoader;
}

export const postAxios = (url, axiosRequestConfig) => {
    axiosRequestConfig.headers = {
        'Url': url,
        'Step': 'DataCall',
        'IsWebService': '0',
        'elapsedTime': 0,
        'browserClientId': getBrowserClientId(),
        env: AppConfig.appMode,
        authorization: AppConfig.getAuthToken(),
        connectionId: sessionStorage.getItem('tabId') ? sessionStorage.getItem('tabId') : AppConfig.env('connectionId'),
    };
    url = AppConfig.apiUrl + url;
    if (!axiosRequestConfig.params.callTime) {
        axiosRequestConfig.params = { ...axiosRequestConfig.params, callTime: new Date() }
    }
    var respLoader = trackPromise
        (axios({
            method: 'post',
            url: url,
            data: axiosRequestConfig.params,
            headers: axiosRequestConfig.headers,
            callTime: axiosRequestConfig.params.callTime,
        })
            .then((response) => {
                return response?.data;;
            })
            .catch((response) => {
                console.log(response);
            }));
    return respLoader;
}
export const getUtcDate = function () {
    var dt = new Date();
    return new Date(dt.getUTCFullYear(), dt.getUTCMonth(), dt.getUTCDate(), dt.getUTCHours(), dt.getUTCMinutes(), dt.getUTCSeconds(), dt.getUTCMilliseconds());
};

export const getCookie = (c_name) => {
    if (document.cookie.length > 0) {
        var c_start = document.cookie.indexOf(c_name + "=");
        if (c_start !== -1) {
            c_start = c_start + c_name.length + 1;
            var c_end = document.cookie.indexOf(";", c_start);
            if (c_end === -1) {
                c_end = document.cookie.length;
            }
            return unescape(document.cookie.substring(c_start, c_end));
        }
    }
    return "";
};

export const postFormData = (url, axiosRequestConfig) => {
    axiosRequestConfig.headers = {
        //userId: localStorage.getItem('userId') ? localStorage.getItem('userId') : AppConfig.env('userId'),
        //userKey: localStorage.getItem('userKey') ? localStorage.getItem('userKey') : AppConfig.env('userKey'),
        //connectionId: sessionStorage.getItem('tabId') ? sessionStorage.getItem('tabId') : AppConfig.env('connectionId'),
        //BrowserSessionId: getCookie('BrowserSessionId'),
        //Authorization: AppConfig.getAuthToken(),
        'TimeStart': getUtcDate().getTime(),
        'Url': url,
        'Step': 'DataCall',
        'IsWebService': '0',
        'elapsedTime': 0,
        'browserClientId': getBrowserClientId(),
        env: AppConfig.appMode,
        connectionId: sessionStorage.getItem('tabId') ? sessionStorage.getItem('tabId') : AppConfig.env('connectionId'),
    };
    url = AppConfig.apiUrl + url;

    var resp = trackPromise(
        axios({
            method: 'post',
            url: url,
            data: axiosRequestConfig.params,
            headers: axiosRequestConfig.headers
        })
            .then((response) => {
                return response;
            })
            .catch((response) => {
                console.log(response);
            })
    );
    return resp;
};